"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectAnalyzeOutputDtoSchema = exports.projectAnalyzeInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
exports.projectAnalyzeInputDtoSchema = z.object({
    projectId: z.string().regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Project), {
        message: 'projectId must be a valid project id',
    }),
    buildId: z.string().regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Build), {
        message: 'buildId must be a valid build id',
    }),
});
exports.projectAnalyzeOutputDtoSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('analyzing'),
    }),
    z.object({
        status: z.literal('payment_required'),
        paymentUnconfirmed: z.boolean(),
        purchaseRecordId: z.string().nullable(),
        hasPaidSubscription: z.boolean(),
        hasStripePaymentInstrument: z.boolean(),
        hasStripeDefaultPaymentInstrument: z.boolean(),
        designMonthsConsumed: z.number().int().min(0),
        designMonthsCommitted: z.number().int().min(0),
    }),
]);
//# sourceMappingURL=project-analyze.dto.js.map